import { Component, Input, inject, OnInit } from '@angular/core';
import { SvgService } from '../../services';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
  standalone: true,
  imports: [AsyncPipe, SanitizeHtmlPipe]
})
export class SvgIconComponent implements OnInit {
  private readonly svgService = inject(SvgService);
  @Input({ required: true }) name!: string;
  @Input() isFromBlob: boolean = false;
  svgIcon$!: Observable<string>;

  ngOnInit(): void {
    this.svgIcon$ = this.svgService.getSvgContent(this.name, this.isFromBlob);
  }
}
